import { showMessageBox } from '../../components/message'
import { formataData, getUrlAction } from '../../utils'
import { estabelecimento } from '../estabelecimento'

let intervalStarted = false
export const getStatusEstabelecimento = () => {
  const span = select('#hr-abertura')

  if (!span) return

  if (estabelecimento.aberto) {
    updateStatus(span, 'Aberto', 'aberto')
  } else {
    updateStatusEstabelecimento(span)
  }

  if (!intervalStarted) {
    intervalStarted = true
    setInterval(() => {
      getStatusEstabelecimento()
    }, 15000)
  }
}

const updateStatus = (element, textContent, className) => {
  element.textContent = textContent
  element.classList = className
}

const updateStatusEstabelecimento = (span) => {
  let isEncontrado = false
  if (estabelecimento.agendamento.somenteAgendamentos) {
    updateStatus(span, 'Somente Agendamentos', 'aberto')
  } else {
    isEncontrado = checkDiasDelivery(span, isEncontrado)
  }

  if (!isEncontrado || estabelecimento.deliveryAutomatico) {
    updateStatusDelivery(span)
  }
}

const checkDiasDelivery = (span, isEncontrado) => {
  const hoje = new Date()

  if (
    estabelecimento.diasDelivery &&
    estabelecimento.diasDelivery.length > 0 &&
    estabelecimento.deliveryAutomatico
  ) {
    const intervalo = estabelecimento.diasDelivery.find(
      (item) => item.DiaDaSemana == hoje.getDay(),
    )

    if (intervalo && intervalo.Intervalos && intervalo.Intervalos.length > 0) {
      isEncontrado = setProximoHorario(span, intervalo, isEncontrado)
    }
  }

  return isEncontrado
}

const setProximoHorario = (span, intervalo, isEncontrado) => {
  intervalo.Intervalos.forEach((item) => {
    try {
      const data = formataData({ data: new Date() })

      if (
        data.dataString + ' ' + item.StartTime > new Date() &&
        !isEncontrado
      ) {
        span.innerHTML = 'Abre às ' + item.StartTime.substring(0, 5)
        isEncontrado = true
      }
    } catch (error) {
      // saveError(error)
    }
  })

  return isEncontrado
}

export async function updateStatusDelivery(span) {
  return new Promise((resolve, reject) => {
    axios
      .get(getUrlAction('Home', 'DeliveryIsOpen'), {
        params: {
          urlEmpresa: estabelecimento.urlEmpresa,
        },
      })
      .then(({ data }) => {
        const dataJs = JSON.parse(data.status)

        if (estabelecimento.deliveryAutomatico) {
          const diaAtual =
            estabelecimento.diasDelivery?.length > 0 &&
            estabelecimento.diasDelivery.find(
              (dia) => dia.DiaDaSemana === new Date().getDay(),
            )
          if (
            diaAtual &&
            diaAtual.Aberto &&
            diaAtual &&
            diaAtual.Intervalos?.length > 0
          ) {
            const intervaloAtual = diaAtual.Intervalos.find((intervalo) => {
              return (
                new Date().toLocaleTimeString('pt-BR') > intervalo.StartTime &&
                new Date().toLocaleTimeString('pt-BR') < intervalo.EndTime
              )
            })

            if (intervaloAtual) {
              estabelecimento.aberto = true
            } else {
              estabelecimento.aberto = false
            }
          }
        } else {
          estabelecimento.aberto = dataJs.DeliveryAberto
        }

        estabelecimento.qrCodeAberto = dataJs.QRCodeAberto

        if (span) {
          if (estabelecimento.qrCode.ativo) {
            estabelecimento.qrCodeAberto
              ? updateStatus(span, 'Aberto', 'aberto')
              : updateStatus(span, 'Fechado', 'fechado')
          } else {
            if (estabelecimento.aberto) {
              updateStatus(span, 'Aberto', 'aberto')
            } else if (estabelecimento.agendamento.somenteAgendamentos) {
              updateStatus(span, 'Somente agendamentos', 'aberto')
            } else {
              updateStatus(span, 'Fechado', 'fechado')
            }
          }
        }


        resolve()
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function validaAberturaEstabelecimento() {

  const abertoQRCode = (estabelecimento.qrCode.ativo && estabelecimento.qrCodeAberto)
  const abertoDelivery = (!estabelecimento.qrCode.ativo && estabelecimento.aberto)
  if (!abertoQRCode && !abertoDelivery) {
    showMessageBox({
      icon: 'warning',
      message: 'O estabelecimento está fechado no momento.',
      classList: 'no-icon-background small',
      default: true,
    })
    return false
  }

  return true
}
